import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-us',
  templateUrl: './choose-us.component.html',
  styleUrls: ['./choose-us.component.scss']
})
export class ChooseUsComponent implements OnInit {

  constructor() { }
  services = [
    {
      imageUrl: '../../../../assets/images/mobile.svg',
      title: 'Excellence Is Our Habit',
      desc: 'We settle for nothing less! We create designs and code to inspire and attract.',
    },
    {
      imageUrl: '../../../../assets/images/bulb.svg',
      title: 'Our Flexibility',
      desc: 'Flexibility allows us to provide our clients with a method that truly suits their individual needs.',
    },
    {
      imageUrl: '../../../../assets/images/medal.svg',
      title: 'Quality of Our Services',
      desc: 'With a team of experienced developers & designers, we maintain quality of our deliverables to such an extent that our deployment of projects and resources is 95%+ success.',
    },
 
  ]
  ngOnInit(): void {
  }

}
